import React from 'react';

export default function ReleaseNotesOverlay({ visible, onClose }) {
  if (!visible) return null;

  const handleClickOutside = (e) => {
    if (e.target.id === 'release-notes-backdrop') {
      onClose();
    }
  };

  const handleDismiss = () => {
    window.dispatchEvent(new Event("releaseNotesDismissed"));
    onClose();
  };

  return (
    <div
      id="release-notes-backdrop"
      onClick={handleClickOutside}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(2px)'
      }}
    >
      <div style={{
        background: 'white',
        width: '500px',
        padding: '2vw',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        position: 'relative',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <button onClick={handleDismiss} style={{
          position: 'absolute',
          top: '10px',
          right: '14px',
          background: 'transparent',
          border: 'none',
          fontSize: '1.2rem',
          cursor: 'pointer'
        }}>✖</button>

        <h2 style={{ margin: '0 0 0.5rem 0', textAlign: 'center' }}>Release Notes BETA 1.0.0</h2>
        <div style={{ fontSize: '0.95rem', color: '#334155' }}>
          <ul>
            <li>📲️ UI optimizations.</li>
            <li>👨‍🏫️ Added instructional animations.</li>
            <li>🔐️ Strengthened security features.</li>
            <li>🪲️ Minor Bugfixes</li>
          </ul>
        </div>

        <button onClick={handleDismiss} style={{
          alignSelf: 'center',
          marginTop: '1rem',
          padding: '10px 20px',
          fontSize: '1rem',
          backgroundColor: '#0ea5e9',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer'
        }}>
          Got it!
        </button>
      </div>
    </div>
  );
}
